import styled from '@emotion/styled';

interface Props {
  children: React.ReactNode;
}

const RenderMarkdown = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #1c1c1e;
  padding: 0;
  @media (max-width: 1024px) {
    padding: 0px 16px;
  }

  div:not(#block-marketing *) {
    padding-left: 0;
    padding-right: 0;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  blockquote {
    padding-left: 16px;
    padding-right: 16px;
    @media (max-width: 640px) {
      margin-left: 8px;
    }
    border: 4px solid #e6e6e6;
  }

  a {
    color: #91121c;
  }

  ol,
  ul {
    margin-bottom: 12px;
    @media (min-width: 640px) {
      padding-left: 12px;
      padding-right: 12px;
    }
    @media (min-width: 720px) {
      padding-left: 4px;
      padding-right: 4px;
    }
  }

  ol li,
  ul li {
    margin-left: 16px;
    padding-left: 8px;
    list-style-position: outside;
  }

  ul li {
    list-style: disc;
  }

  ol li {
    list-style: decimal;
  }

  figcaption {
    text-align: center;
    margin-top: 8px;
    @media (min-width: 640px) {
      font-size: 16px;
    }
    @media (min-width: 720px) {
      font-size: 14px;
    }

    em {
      font-size: 16px;
    }
  }

  table {
    width: 100%;

    @media (min-width: 640px) {
      font-size: 14px;
    }
    @media (min-width: 720px) {
      font-size: 16px;
    }
    border-bottom: 2px solid #f3f4f6;

    th,
    td {
      text-align: center;
      padding: 16px;
      border-bottom: 2px solid #f3f4f6;
    }

    tr {
      :hover {
        border: 1px solid #f3f4f6;
      }
    }
  }

  img {
    margin-left: auto;
    margin-right: auto;
  }

  figure {
    max-width: 100%;
    margin-bottom: 8px;
  }

  strong {
    font-weight: 500;
  }

  h2 {
    font-size: 24px;
    line-height: 30px;
    text-align: left;
  }

  h3 {
    font-size: 22px;
    line-height: 28px;
  }

  h4 {
    font-size: 18px;
    line-height: 24px;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  h5 {
    font-size: 16px;
    line-height: 20px;
    margin-top: 8px;
    margin-bottom: 8px;
    font-weight: 500;
  }

  h2:not(#block-marketing *),
  h3:not(#block-marketing *),
  h4:not(#block-marketing *) {
    font-size: 16px;
    line-height: 20px;
    margin-top: 8px;
    margin-bottom: 8px;
    font-weight: 500;

    span {
      font-weight: inherit !important;
    }
  }

  p:not(#block-marketing *) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 12px;
  }
`;

export const JobDetailsStyle: React.FC<Props> = ({ children }) => {
  return <RenderMarkdown>{children}</RenderMarkdown>;
};
